import { TnAEmployeeAnomaliesDTO } from "../../models/tna-employee-anomalies";
import { BaseApiService } from "../base/base-api.service";

export class EmployeeAnomaliesQueryApiService extends BaseApiService<TnAEmployeeAnomaliesDTO, TnAEmployeeAnomaliesDTO> {
  constructor() {
    super({
      servicePath: "/TnAData",
      loadItemsPath: "/GetTnAEmployeeAnomaliesQuery",
    });
  }
}
